import React, { Component } from 'react';
import { Step, StepGroup, Stepper } from '@cimpress/react-components';

export default class StepperDemo extends Component {
  state = {
    activeStep: '1',
    verticalActiveStep: '1',
  };

  setStep = index => {
    this.setState({ activeStep: index });
  };

  setVerticalStep = index => {
    this.setState({ verticalActiveStep: index });
  };

  render() {
    const checkmarkIcon = '✓';

    return (
      <div>
        <Stepper activeStep={this.state.activeStep}>
          <Step onClick={this.setStep}>
            <div>Step One</div>
            <small>A step</small>
          </Step>
          <Step onClick={this.setStep}>
            <div>Step Two</div>
            <small>It's another step!</small>
          </Step>
          <Step onClick={this.setStep} tip="Lorem ipsum tipsum">
            <div>Step Three</div>
            <small>A third step</small>
          </Step>
        </Stepper>
        <h5>Another stepper...</h5>
        <div style={{ width: '200px' }}>
          <Stepper small activeStep="3" status="warning">
            <Step name="order accepted" tip="Order accepted by the platform" />
            <Step name="doc review" tip="Document successfully rendered" />
            <Step name="inventory" tip="Inventory check passed" />
            <Step name="processing" tip="Order processed" />
            <Step name="production" tip="In production" tipDirection="bottom" />
            <Step name="shipped" tip="Shipped" />
          </Stepper>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px' }}>
          <div>
            <h5>Vertical Stepper with SubSteps</h5>
            <p>Nested steps with a StepGroup are only supported for full-sized vertical steppers.</p>
            <div style={{ height: '330px' }}>
              <Stepper activeStep={this.state.verticalActiveStep} vertical>
                <Step onClick={this.setVerticalStep}>
                  <div>Step One</div>
                  <small>A step</small>
                </Step>
                <Step overrideStatus="warning" onClick={this.setVerticalStep}>
                  <div>Step Two</div>
                </Step>
                <StepGroup onClick={this.setVerticalStep} tip="Lorem ipsum tipsum" contents={<div>Step Three</div>}>
                  <Step
                    overrideStatus="danger"
                    tip="This step causes Step Three to inherit the danger color"
                    onClick={this.setVerticalStep}
                  >
                    <div>Sub-step one</div>
                  </Step>
                  <Step overrideStatus="warning" onClick={this.setVerticalStep}>
                    <div>Sub-step two</div>
                  </Step>
                  <Step onClick={this.setVerticalStep}>
                    <div>Sub-step three</div>
                  </Step>
                </StepGroup>
                <Step onClick={this.setVerticalStep} icon={checkmarkIcon}>
                  <div>Step With Custom Icon</div>
                </Step>
              </Stepper>
            </div>
          </div>
          <div style={{ height: '550px' }}>
            <h5>Small Vertical Stepper</h5>
            <div style={{ height: '250px' }}>
              <Stepper small vertical activeStep="3" partial status="warning">
                <Step name="order accepted" tip="Order accepted by the platform" tipDirection="right" />
                <Step name="doc review" tip="Document successfully rendered" tipDirection="right" />
                <Step name="inventory" tip="Inventory check passed" tipDirection="right" />
                <Step name="processing" tip="Order processed" tipDirection="right" />
                <Step name="production" tip="In production" tipDirection="right" />
                <Step name="shipped" tip="Shipped" tipDirection="right" />
              </Stepper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
